module.exports = __webpack_public_path__ + "static/gallery_back-10ef82c38b460d23f58db3d7895c6ec5.png";